/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'CHILD_LABOR_AND_OR_YOUNG_WORKERS',
              'PROHIBITION_OF_FORCED_LABOR',
              'ANTI_HARASSMENT_AND_ABUSE',
              'ANTI_DISCRIMINATION',
              'WORKING_HOURS',
              'WAGES_AND_BENEFITS',
              'DISCIPLINE',
              'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
              'WORKER_FEEDBACK',
              'GRIEVANCE_SYSTEMS',
              'HEALTH_AND_SAFETY',
              'FOREIGN_MIGRANT_WORKERS',
              'DOMESTIC_MIGRANT_WORKERS',
              'HOMEWORKERS',
              'GENDER_EQUALITY_AND_WOMEN_S_RIGHTS_IN_THE_WORKPLACE',
              'BRIBERY_AND_ANTI_CORRUPTION',
              'SUPPLIERS_SUBCONTRACTORS',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    has_the_fac_set_targets_for_social_and_labor_performance_addres: valueSchema,
  },
}
